// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCs3aHKNm71c2tvtepBavWuab-du-gOWHo",
  authDomain: "faktura-appen.firebaseapp.com",
  projectId: "faktura-appen",
  storageBucket: "faktura-appen.firebasestorage.app",
  messagingSenderId: "551282997333",
  appId: "1:551282997333:web:a3755c34ff3269d7eafcdc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app)
const functions = getFunctions(app, 'europe-west3')

// Check if the environment is development and connect to the emulators
if (window.location.hostname === "localhost") {
  console.log('connecting the emulator')
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export { db, auth, storage, functions }
